import { API_CONFIG } from '@/config/api.config';

export async function fetchIndustries() {
    const API_BASE = API_CONFIG.API_GATEWAY;
    const TENANT_ID = API_CONFIG.TENANT_ID;

    try {
        const response = await fetch(`${API_BASE}/v1/public/industries`, {
            headers: {
                "X-Tenant-Id": TENANT_ID,
                "Content-Type": "application/json"
            },
            next: { revalidate: 3600 }
        });

        if (!response.ok) {
            console.error(`Failed to fetch industries: ${response.statusText}`);
            return [];
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (err) {
        console.error('Error fetching industries:', err);
        return [];
    }
}

export async function fetchSubIndustries(industryId: string) {
    const API_BASE = API_CONFIG.API_GATEWAY;
    const TENANT_ID = API_CONFIG.TENANT_ID;

    try {
        const response = await fetch(`${API_BASE}/v1/public/industries/${industryId}/sub-industries`, {
            headers: {
                "X-Tenant-Id": TENANT_ID,
                "Content-Type": "application/json"
            },
            next: { revalidate: 3600 }
        });

        if (!response.ok) {
            console.error(`Failed to fetch sub-industries for ${industryId}: ${response.statusText}`);
            return [];
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (err) {
        console.error(`Error fetching sub-industries for ${industryId}:`, err);
        return [];
    }
}

export async function fetchReports(industryKey: string, subIndustryId?: string, limit?: number) {
    const API_BASE = API_CONFIG.API_GATEWAY;
    const TENANT_ID = API_CONFIG.TENANT_ID;

    try {
        let url = `${API_BASE}/v1/public/reports?industry_key=${industryKey}`;
        if (subIndustryId) {
            url += `&sub_industry_id=${subIndustryId}`;
        }
        if (limit) {
            url += `&limit=${limit}`;
        }

        const response = await fetch(url, {
            headers: {
                "X-Tenant-Id": TENANT_ID,
                "Content-Type": "application/json"
            },
            next: { revalidate: 3600 } // Revalidate every hour
        });

        if (!response.ok) {
            console.error(`Failed to fetch reports for ${industryKey}: ${response.statusText}`);
            return [];
        }

        const data = await response.json();
        return Array.isArray(data) ? data : (data.items || data.data || []);
    } catch (err) {
        console.error(`Error fetching reports for ${industryKey}:`, err);
        return [];
    }
}
